export default __webpack_public_path__ + "static/media/7.a98c5982.jpg";